var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIconTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ButtonIcon_test",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.601,
    height: 66.894,
    viewBox: "0 0 68.601 66.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_988",
    "data-name": "Tracciato 988",
    d: "M19.19,0,.666,16.879,0,41.729,9.351,61.408l23.775,5.486,23.13-10.3L68.6,33.472,58.469,5.173,31.125.154Z",
    transform: "translate(0 0)",
    fill: "#c78b43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_989",
    "data-name": "Tracciato 989",
    d: "M7.975,20.716,9.26,19.16l1.629-3.465.2-1.168.472-11,.187-.546L16.99,3.1l.529.42-.467,10.852.584,1.64,2.158,2.885,1.1,1.921ZM10.773,0,6.1.271l.983,1.118,1,1.594.494.548-.1,10.336-.1.989L0,29.045l1.346,1.424,5.059.637,7.851.006,2.4-.158,5.937-.021,3.84.1,2.671-1.926L20.745,14.484l-.582-.4L20.033,3.47l.611-.16-.025-.3.094-.557-.071-.948L20.792.113Z",
    transform: "translate(17.461 17.104)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconTest);
export default __webpack_public_path__ + "static/media/ButtonIcon_test.fbd5bbf7611453753eac51561fc6eaf0.svg";
export { ForwardRef as ReactComponent };